import React from "react";
import Cards from "./Cards";

const Shop = () => {
    return (
        <div className=" ">
            <h1 className=" text-3xl md:text-5xl font-bold m-10  text-center">Hot Drops 🔥</h1>
            <Cards />
        </div>
    );
};

export default Shop;
